import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import track from 'utils/track';
import Card from 'components/Card';
import { Billboard, VerticalCard, HorizontalCard } from 'components/ContentCards';
import PageSection from 'components/PageSection';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import PlaylistHeader from 'components/PlaylistHeader';
import Box from 'components/Box';
import ResponsiveUserBadgeImage from 'components/UserBadgeImage/ResponsiveUserBadgeImage';
import { BADGE_SIZE_SMALL, BADGE_SIZE_LARGE, PlaylistBannerBadge, Section, Sidebar, SidebarWrapper } from '../../../../main/components/pages/playlist/Layout';
import { ExampleDescription } from '../common';
import ActionWrapper from '../common/ActionWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ExamplePlaylistCard(_ref) {
  var data = _ref.data,
    previewUrl = _ref.previewUrl;
  var id = data.id,
    thumbnailId = data.thumbnailId,
    name = data.name,
    description = data.description,
    badge = data.badge;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(VerticalCard, {
    icon: "playlist",
    id: "card-preview-".concat(id === null || id === void 0 ? void 0 : id.toString()),
    imageSource: previewUrl || getPictureUrl({
      id: thumbnailId,
      dimensions: DIMENSIONS.VERTICAL_CARD
    }),
    title: name,
    subtitle: t('content_type_playlist'),
    description: description,
    compactLayoutBreakpoint: "m",
    badge: badge,
    hasUserBadge: true
  });
}
function PlaylistThumbnailPreview(_ref2) {
  var _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    data = _ref2.data,
    previewUrl = _ref2.previewUrl,
    onClose = _ref2.onClose,
    onReset = _ref2.onReset,
    onUpload = _ref2.onUpload,
    onReplace = _ref2.onReplace;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isUploading = _React$useState2[0],
    setIsUploading = _React$useState2[1];
  var thumbnailId = data.thumbnailId,
    id = data.id,
    name = data.name,
    description = data.description,
    badge = data.badge;
  var isNewImage = !!previewUrl;
  var hasPlaylistBadge = !!badge && Boolean(badge.id && !badge.isDeleted);
  var playlistUrl = id ? "".concat(window.location.origin, "/playlists/").concat(id) : undefined;
  var refId = id ? +id : null;
  function handleConfirm() {
    return _handleConfirm.apply(this, arguments);
  }
  function _handleConfirm() {
    _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window$heap3;
      var _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsUploading(true);
            if (!onUpload) {
              _context.next = 4;
              break;
            }
            _context.prev = 1;
            _context.next = 2;
            return onUpload();
          case 2:
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setIsUploading(false);
          case 4:
            track('collection', 'update', 'thumbnailUpload:confirmed', refId);
            (_window$heap3 = window.heap) === null || _window$heap3 === void 0 || _window$heap3.track('Thumbnail upload confirmed', {
              playlistUrl: playlistUrl
            });
            onClose();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return _handleConfirm.apply(this, arguments);
  }
  function trackCancelAction() {
    var _window$heap;
    track('collection', 'update', 'thumbnailUpload:cancelled', refId);
    (_window$heap = window.heap) === null || _window$heap === void 0 || _window$heap.track('Thumbnail upload cancelled', {
      playlistUrl: playlistUrl
    });
  }
  function handleCancel() {
    trackCancelAction();
    onReset();
  }
  function handleClose() {
    if (isNewImage) {
      trackCancelAction();
    }
    onClose();
  }
  function handleReplace(_ref3) {
    var _window$heap2;
    var file = _ref3.file;
    track('collection', 'update', 'thumbnailUpload:newUpload', refId);
    (_window$heap2 = window.heap) === null || _window$heap2 === void 0 || _window$heap2.track('Thumbnail new upload', {
      playlistUrl: playlistUrl
    });
    onReplace({
      file: file
    });
  }
  return /*#__PURE__*/_jsxs(ActionWrapper, {
    id: "preview-playlist-modal",
    guideTitle: t('thumbnail_guideline_playlists_title'),
    recommendations: [t('thumbnail_guideline_playlists_recommendation_1'), t('thumbnail_guideline_playlists_recommendation_2'), t('thumbnail_guideline_playlists_recommendation_3'), t('thumbnail_guideline_playlists_recommendation_4')],
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    onClose: handleClose,
    onReplace: handleReplace,
    previewUrl: previewUrl,
    isDisabled: isDisabled || isUploading,
    children: [/*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(ExampleDescription, {
        titleKey: "thumbnail_playlist_size_title",
        descriptionKey: "thumbnail_playlist_size_description"
      }), /*#__PURE__*/_jsxs(Card, {
        children: [/*#__PURE__*/_jsx(PlaylistHeader, {
          isReady: true,
          thumbnailId: thumbnailId,
          previewUrl: previewUrl
        }), hasPlaylistBadge && /*#__PURE__*/_jsxs(Section, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(PlaylistBannerBadge, {
            children: /*#__PURE__*/_jsx(ResponsiveUserBadgeImage, {
              badge: badge,
              hasUserBadge: true,
              sizes: [BADGE_SIZE_SMALL, BADGE_SIZE_LARGE],
              breakpoints: ['base', 'xs']
            })
          }), /*#__PURE__*/_jsx(SidebarWrapper, {
            children: /*#__PURE__*/_jsx(Sidebar, {
              makeSpaceForBadge: true
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(ExampleDescription, {
        titleKey: "thumbnail_billboard_size_title",
        descriptionKey: "thumbnail_billboard_size_description"
      }), /*#__PURE__*/_jsx(Billboard, {
        icon: "playlist",
        id: "billboard-preview-".concat(id),
        imageSource: previewUrl || getPictureUrl({
          id: thumbnailId,
          dimensions: DIMENSIONS.BILLBOARD
        }),
        title: name,
        subtitle: t('content_type_playlist'),
        description: description,
        badge: badge,
        hasUserBadge: true
      })]
    }), /*#__PURE__*/_jsxs(PageSection, {
      children: [/*#__PURE__*/_jsx(ExampleDescription, {
        titleKey: "thumbnail_playlist_content_size_title",
        descriptionKey: "thumbnail_playlist_content_size_description"
      }), /*#__PURE__*/_jsx(HorizontalCard, {
        icon: "playlist",
        id: "horizontal-card-preview-".concat(id),
        imageSource: previewUrl || getPictureUrl({
          id: thumbnailId,
          dimensions: DIMENSIONS.HORIZONTAL_CARD
        }),
        title: name,
        subtitle: t('content_type_playlist'),
        description: description,
        compactLayoutBreakpoint: "m"
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsxs(CollectionGrid, {
        children: [/*#__PURE__*/_jsx(CollectionGridItem, {
          children: /*#__PURE__*/_jsxs(Box, {
            width: "100%",
            height: "min-content",
            children: [/*#__PURE__*/_jsx(ExampleDescription, {
              titleKey: "thumbnail_standard_card_size_title",
              descriptionKey: "thumbnail_standard_card_size_description"
            }), /*#__PURE__*/_jsx(ExamplePlaylistCard, {
              previewUrl: previewUrl,
              data: data
            })]
          })
        }), /*#__PURE__*/_jsx(CollectionGridItem, {
          large: true,
          children: /*#__PURE__*/_jsxs(Box, {
            width: "100%",
            height: "min-content",
            children: [/*#__PURE__*/_jsx(ExampleDescription, {
              titleKey: "thumbnail_large_card_size_title",
              descriptionKey: "thumbnail_large_card_size_description"
            }), /*#__PURE__*/_jsx(ExamplePlaylistCard, {
              previewUrl: previewUrl,
              data: data
            })]
          })
        })]
      })
    })]
  });
}
export default PlaylistThumbnailPreview;